import firebase from './../services/firebase';

import types from './mutation-types';
import openLigaDbService from '../services/openLigaDb';

export default {
  async fetchLatestMatch({ commit }) {
    try {
      const response = await openLigaDbService.fetchLatestMatches();

      // Filter for a 1860 match.
      const TSV_ID = 125;
      const filteredMatches = response
        .filter(match => match.Team1.TeamId === TSV_ID || match.Team2.TeamId === TSV_ID);

      if (filteredMatches.length !== 1) {
        return;
      }
      if (!filteredMatches[0].Team1
        || !filteredMatches[0].Team2
        || !filteredMatches[0].Goals[0]) {
        return;
      }
      const match = {
        home: openLigaDbService.getShortTeamName(filteredMatches[0].Team1.TeamName || 'Heim'),
        guest: openLigaDbService.getShortTeamName(filteredMatches[0].Team2.TeamName || 'Gast'),
        goalsHome: filteredMatches[0].Goals[0].ScoreTeam1 || 0,
        goalsGuest: filteredMatches[0].Goals[0].ScoreTeam2 || 0,
        date: filteredMatches[0].MatchDateTime || '',
      };
      commit(types.SET_LATEST_MATCH_DATA, match);

      // Add the match into the firebase database.
      // Just for fun.
      const ref = firebase.database.ref('matches');
      ref.orderByChild('date').equalTo(match.date).once('value', (snapshot) => {
        if (!snapshot.exists()) {
          ref.push(match);
        }
      });
    } catch (error) {
      /* do nothing for now */
    }
  },
  async fetchTableData({ commit }) {
    const response = await openLigaDbService.fetchTableData();
    try {
      if (!response || response.length <= 0) {
        return;
      }

      const td = response.map(team => ({
        name: openLigaDbService.getShortTeamName(team.TeamName),
        matches: team.Matches,
        points: team.Points,
        won: team.Won,
        lost: team.Lost,
        draw: team.Draw,
        goals: team.Goals,
        opponentGoals: team.OpponentGoals,
        goalDifference: team.GoalDiff,
      }));

      commit(types.SET_TABLE_DATA, td);
    } catch (error) {
      /* do nothing for now */
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js